import {useQuery, useMutation} from "@tanstack/react-query"
import { clientId, seedValue, timestamp } from "./utils"
import axios from "axios"

const instance = axios.create({
    baseURL:process.env.REACT_APP_BASE_URL
})
instance.interceptors.request.use(config => {
    config.headers["X-Client-Id"]= clientId
    config.headers["X-Seed-Id"]= seedValue
    config.headers["X-TimeStamp"]= timestamp
    config.headers["X-API-Key"] = "123456"
    return config
})

async function getter(url) {
    const { data } = await instance.get(url)
    return data
} 
const useFetchTitles = () => {
    async function fetchTitles() {
        const { data } = await instance.get("/onboarding-service/api/v1/Utility/GetTitles")
        return data
    } 
    const queryTitles = useQuery({ queryKey: ["fetch-titles"], queryFn: fetchTitles, refetchOnWindowFocus:false })
    return queryTitles
}
const useFetchCountries=() => {
    const data = () => getter("/onboarding-service/api/odata/Country")
    const queryCountries= useQuery({ queryKey: ["fetch-countries"], queryFn: data, refetchOnWindowFocus:false , })
return queryCountries
}
const useFetchStates=(country) => {
    const data = () => getter(`/onboarding-service/api/odata/Country?$filter=CountryName eq '${country}'&$expand=States`)
    const queryCountries= useQuery({ queryKey: ["fetch-countries", country], queryFn: data, refetchOnWindowFocus:false, enabled:!!country })
return queryCountries
}
const useFetchBanks = () => {
    async function fetchBanks() {
        const { data } = await instance.get(`/onboarding-service/api/v1/Utility/GetAllBanks`)
        data.result.map(res => {
            res.label=res.bankDescription
            res.value = res.bankName
            return res
        })
        // console.log({data})
        return data
    } 
   
    const queryBanks= useQuery({ queryKey: ["fetch-banks"], queryFn: fetchBanks,  refetchOnWindowFocus:false })
return queryBanks
}

export const useFetchBankAccountName = () => {
    // console.log({payload})
    async function fetchName(payload) {
        const {data}= await instance.post("/onboarding-service/api/v1/Customer/Bank/NameEnquiry", payload)
    return data
    }
    const queryName = useMutation({
        mutationKey: ["fetch-bank-account-name",
           ], mutationFn: fetchName
    })
return queryName
}
export const useFetchBidPrice = () => {
    async function fetchBid() {
        const { data } = await instance.get(`/onboarding-service/api/v1/Utility/Funds/GetPrices`)
     
        // console.log({data})
        return data
    } 
   
    const queryBid= useQuery({ queryKey: ["fetch-bid"], queryFn: fetchBid,  refetchOnWindowFocus:false })
return queryBid
}
export const useValidateBVNDetails = () => {
    async function validateBVNDetails(payload) {
        const { data } = await instance.post(`/onboarding-service/api/v1/Customer/BVN/validate`, payload)
     
        // console.log({data})
        return data
    } 
   
    const queryBVNDetails= useMutation({mutationFn:validateBVNDetails, mutationKey:["validate-bvn-details"]})
return queryBVNDetails
}

export {instance, useFetchTitles, useFetchCountries, useFetchStates, useFetchBanks}